<template>
	<div id="robredbaglist" :class="{robing:(list.status == 'is_close')}">
		<div class="topView">
			<div class="header" :style="'background-image:url('+imgPath+'redbag/redheader_03.png)'">
				<img :src="imgPath+'close.png'" class="close" @click="close">
				<img class="hb_headerImage" :src="man.header"/>
		    </div>
			<template v-if="list.status != 'is_close'">
				<p class="userNameLabel">{{man.nick}}的红包<span class="hb_ping">拼</span></p>

				<div class="midContent" v-if="list.amount">
					<p class="redtext" v-if="man.content" >{{man.content}}</p>
		          	<p class="redtext" v-else>恭喜发财，大吉大利</p>
		            <p class="redmoney">{{list.amount}}<span class="yuan">元</span></p>
	                <p class="detail">已存入零钱，可 <van-button type="primary" size="mini" @click="cash">提现</van-button></p>
				</div>
		        <p class="redtext" v-else>手慢了,红包派完了</p>
			</template>
	    </div>
		
		<div class="lists" v-if="list.status != 'is_close'">
    	    <div class="list-row clearfix" v-for="(item,index) in list.list" :key="index">
	    	   <img :src="item.header"/>
	    	   <div class="redbag_box">
	    	   	  <span class="otherName">{{item.nick}}</span>
	    	   	  <span class="other_money fr">{{item.amount/100}} 元</span>
	    	   	  <p class="othertime">{{item.create_time}}</p>
	    	   </div>
    	    </div>
		</div>

		<div class="redbagBottom" v-else>
			<p class="userNameLabel">{{man.nick}}</p>
			<p class="userNamebottomLabel" ></p>
			<p class="userNamebottomLabel">给你发了个红包</p>
			<p class="redtext" v-if="man.content">{{man.conent}}</p>
			<p class="redtext" v-else>恭喜发财,大吉大利</p>
            <i class="openimage" @click="openAction" :style="'background-image:url('+imgPath+'redbag/open_10.png)'"></i>
            <i class="iconi-image" :style="'background-image:url('+imgPath+'redbag/redbottomImage_10.png)'"></i>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import { Button } from 'vant';
Vue.use(Button);
	export default {
		data(){
			return {
				imgPath:''
			}
		},
    	props:['man','list'],
    	mounted(){
			this.imgPath = tool.imgPath();
    	},
    	methods:{
			cash(){
				this.$router.push({
					name:'UserInfo'
				})
			},
    		close(){
    			this.$emit('close');
    		},
    		openAction(){
    			this.list.status = 'is_open';
    		}
    	}
    }
</script>

<style scoped>
.robing{
	color: rgb(244,215,157);
	background: rgb(234,37,29);
}
#robredbaglist{
	margin: -10px;
	border-radius: 10px;
	overflow: hidden;
}
.topView{
    padding-bottom: 10px;
}
.header{
	background-repeat: no-repeat;
	background-size: 100% 100%;
	height: 60px;
}
.hb_headerImage{
	position: absolute;
	top: 30px;
	left: 50%;
	margin-left: -25px;
	height: 50px;
	width: 50px;
	border-radius: 5px;
	border:2px solid #f4d79d;
}
.lists{
	min-height:200px;
	max-height:300px;
	overflow: auto;
	-webkit-overflow-scrolling: touch;
}
.userNameLabel{
	margin-top: 30px;
	text-align: center;
}
.userNamebottomLabel{
	margin-top: 5px;
	text-align: center;
	font-size: 15px;

}
.redtext{
	margin: auto;
	margin-top: 5px;
	text-align: center;
	width: 80%;
	font-size: 12px;
}
.hb_ping{
	display: inline-block;
	background-color:#ffbb29;
	color: white;
	padding: 0 4px;
	border-radius: 3px;
	margin-left: 10px;
	font-size: 10px;
}
.redmoney{
	padding-top: 5px;
	text-align: center;
	font-size: 40px;
	color: #F99C3A;
}
.yuan{
	font-size: 10px;
	padding-left: 5px;
}
.detail{
	padding-top: 10px;
	text-align: center;
	color: #5074bd;
	font-size: 13px;
}
.status{
	padding: 10px 20px;
	color: #6a6a6a;
	border-bottom: #d2d2d2 1px solid;
}
.list-row{
	padding: 4px;
	border-bottom: 1px #F1F1F1 solid;
}
.list-row img{
	float: left;
	width: 50px;
	border-radius: 10px;
}
.redbag_box{
	padding:5px 15px;
	padding-left: 55px;
}
.otherName{
	color: #242424;
}
.othertime{
	color: #a5a5a5;
	padding-top: 5px;
}
.other_money{
	color: #F99C3A;
}
.openimage{
  	 display: block;
  	 width: 100px;
  	 height: 100px;
  	 background-size: 100% 100%;
  	 margin: auto;
  	 margin-top: 30px;
  }
	
	.iconi-image{
	 display: block;
  	 width: 20px;
  	 height: 20px;
  	 background-size: 100% 100%;
  	 margin: auto;
  	 margin-top: 40px;

	}
</style>